export default {
  dashboardv2: {
    usersByStatus: "Pengguna Menurut Status",
    allTime: "Sepanjang Waktu",
    noOfUsers: "Jumlah Pengguna",
    usersByGender: "Pengguna Menurut Jenis Kelamin",
    gender: "Jenis Kelamin",
    farmerName: "Nama Petani",
    farmerProduction: "Produksi Petani",
    production: "Produksi",
    plan: "Rencana",
    expiryDate: "Tanggal Kedaluwarsa",
    buyingStationProduction: "Produksi Stasiun Pembelian",
    dryMillingProduction: "Produksi Penggilingan Kering",
    usersPerMembershipPlans: "Pengguna Per Rencana Keanggotaan",
    planType: "Tipe Rencana",
    users: "Pengguna",
    planValidity: "Validitas Rencana",
    averageSellingPriceByAllFarmers: "Harga Jual Rata-rata oleh Semua Petani",
    avgSellingPrice: "Harga Jual Rata-rata",
    pricePaid: "Harga yang Dibayar",
    avgSellingPricePerFarmer: "Harga Jual Rata-rata per Petani",
    exportAsCSV: "Ekspor Sebagai CSV",
    exportAsXLS: "Ekspor Sebagai XLS",

    filterByFarm: "Filter Berdasarkan Perkebunan",
    searchFarms: "Cari Perkebunan",
    filterByRegion: "Filter Berdasarkan Wilayah",
  },
  dashboardSection: {
    greenBeansData: "Manajemen Kacang Hijau",
    dryMilling: "Penggilingan Kering",
    modules: "Modul",
    allowances: "Izin",
    maxUserAllowed: "Pengguna Maksimal Diizinkan",
    satelliteReportsAllowed: "Laporan Satelit Diizinkan",
    advanceReport: "Laporan Lanjutan Diizinkan",
    subscriptionUpTo: "Berlangganan Sampai",
    roleAllowed: "Peran Diizinkan",
    moduleAllowed: "Modul Diizinkan",
    registeredUsers: "Pengguna Terdaftar",
    validMemberships: "Keanggotaan Valid",
    activeUsers: "Pengguna Aktif",
    deactivatedUsers: "Pengguna Nonaktif",
    membershipValidity: "Validitas Keanggotaan",
    lessThan1Month: "Kurang dari 1 Bulan",
    months1to6: "1-6 Bulan",
    months6to12: "6-12 Bulan",
    moreThan1Year: "Lebih dari 1 Tahun",
    cropOverview: "Gambaran Tanaman",
    plantations: "Perkebunan",
    coffeeData: "Data Kopi",
    availableModules: "Modul Tersedia",
    roleList: "Petani, Stasiun Pembelian, Gudang",
    memberData: "Data Anggota",
    userType: "Tipe Pengguna",
    registered: "Terdaftar",
    offlineUsers: "Pengguna Offline",
    lessThanOneMonth: "< 1 Bulan",
    cacaoData: "Data Kakao",
    dryCacao: "Kakao Kering",
    traceability: "Pelacakan",
    allFarm: "Semua Pertanian",
  },
  dashboardReports: {
    appDataReports: "Laporan Data Aplikasi",
    reports: "Laporan",
  },
};
